import React from "react";
import SystemGeneratorPage from "./SystemGeneratorPage";
import "./RecruitmentSystemsPage.css";

function Rec2RecSystemsPage({ business = null }) {
  return (
    <div className="recruitment-simple">
      <section className="recruitment-simple__intro">
        <div className="recruitment-simple__badge">Rec2Rec</div>
        <h2>Confidential recruiter profile (2 mins)</h2>
        <p>
          Helps us understand your desk, billings and move criteria before
          introducing you to agencies.
        </p>
        <p>Your current employer is never contacted and your profile is only shared with your approval.</p>
        <p className="recruitment-simple__plan">Free plan</p>
        <div className="recruitment-simple__example">
          <p>Example</p>
          <pre>
            {`Confidential recruiter profile. Capture 180/270/360, sector, perm/contract split,
billings last 12 months, move readiness, base salary, notice period, and relocation openness.`}
          </pre>
        </div>
      </section>
      <SystemGeneratorPage
        business={business}
        systemTypeOverride="recruitment"
        rec2recDefault={true}
        activeTabOverride="rec2rec"
      />
    </div>
  );
}

export default Rec2RecSystemsPage;
